import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ReplyIcon(props: IconProps) {
    return <Icon {...props} iconKey={"reply"}/>
}
